// extracted by mini-css-extract-plugin
export var audioPlayer = "_rr-0";